interface Vehicle {
  id: string;
  name: string;
  vehicleType?: string;
  maxLoadingWeight?: number;
  pallets: number;
  ldmm: number;
  vehicleCapabilities?: VehicleCapabilities[];
  costCalculationId?: string;
  tenantId: string;
  version: number;
}
interface VehicleInput {
  name: string;
  vehicleType?: string;
  maxLoadingWeight?: number;
  ldmm: number;
  vehicleCapabilities?: VehicleCapabilities[];
  costCalculationId?: string;
}
interface VehicleFilters {
  name?: string;
  vehicleType?: string;
  maxLoadingWeight?: string;
  ldmm?: number;
  vehicleCapabilities?: string;
}

interface VehicleArgs {
  skip?: number;
  take?: number;
  filters?: VehicleFilters[];
  sortBy?: string;
  order?: string;
}

interface UpdateVehicleInput {
  name?: string;
  vehicleType?: string;
  maxLoadingWeight?: number;
  ldmm?: number;
  vehicleCapabilities?: VehicleCapabilities[];
  costCalculationId?: string;
}

interface GetVehiclesResult {
  totalCount: number;
  filteredCount: number;
  vehicles: Vehicle[];
}

enum VehicleCapabilities {
  Cooled = 'Cooled',
  SideLoading = 'SideLoading',
  RearLoading = 'RearLoading',
  Curtainsider = 'Curtainsider',
  Edscha = 'Edscha',
  Sidewalls = 'Sidewalls',
  PortableForklift = 'PortableForklift',
  HydraulicRamp = 'HydraulicRamp',
  CodeXL = 'CodeXL',
  PerforatedStrip = 'PerforatedStrip',
  PalletTruck = 'PalletTruck',
  Crane = 'Crane',
  CoilTruck = 'CoilTruck',
  JolodaSystem = 'JolodaSystem',
  TensionBelts = 'TensionBelts',
  SideBoards = 'SideBoards',
  Clipboards = 'Clipboards',
  TensionChains = 'TensionChains',
  LockingBars = 'LockingBars',
  Kantenschoner = 'Kantenschoner',
  AntiSlipMat = 'AntiSlipMat',
}

export {
  VehicleCapabilities,
  Vehicle,
  VehicleArgs,
  VehicleInput,
  UpdateVehicleInput,
  VehicleFilters,
  GetVehiclesResult,
};
